// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Rylb","list":"styles_list__6H0l4"};